import PromoFactory from './promo-factory.js';

if (module.hot) {
	module.hot.accept();
}

export default {
	id: process.env.PKG_NAME,
	version: process.env.PKG_VERSION,
	Factory: PromoFactory
};
